import React from 'react';
import { FileText, Zap, ShieldCheck, Lock, ArrowRight } from 'lucide-react';
import { Button, Badge } from './ui';
import { MOCKUP_URL } from '../data/kit';
export function Hero() {
  return <section className="bg-cream-50 min-h-screen min-h-[100svh] flex flex-col justify-center pt-2 pb-4 sm:pt-5 sm:pb-12 md:pt-8 md:pb-16 px-4" data-id="element-129" data-mp="9ka5gxomiqwe">
      <div className="w-full max-w-5xl mx-auto text-center" data-id="element-130" data-mp="4na0kq3ifu6v">
        <div className="inline-flex items-center gap-1.5 sm:gap-2 mb-1 sm:mb-4" data-id="element-131" data-mp="129qurmgy5roe">
          <span className="text-base sm:text-xl" aria-hidden="true" data-id="element-132" data-mp="xanojyp8dfeu">🌿</span>
          <span className="text-rose-600 font-bold tracking-widest uppercase text-xs sm:text-sm" data-id="element-133" data-mp="x8jm7l6zcogo">
            PUNTO DIGITAL™
          </span>
        </div>

        <h1 className="font-serif font-bold text-wine tracking-tight leading-[1.02] sm:leading-[1.08]" data-id="element-134" data-mp="nb6n5th0hnoo">
          <span className="block text-[23px] sm:text-4xl md:text-[44px]" data-id="element-135" data-mp="3d2bhzk51cpsw">
            ENTENDÉ QUÉ TE ESTÁ PASANDO
          </span>
          <span className="block text-rose-600 text-[26px] sm:text-5xl md:text-[58px] my-0.5 sm:my-1" data-id="element-136" data-mp="384jtl03lnltg">
            Y SABÉ POR DÓNDE EMPEZAR
          </span>
          <span className="block text-[23px] sm:text-4xl md:text-[44px]" data-id="element-137" data-mp="3o6ki7px9iq8t">
            EN SOLO 7 DÍAS.
          </span>
        </h1>

        <div className="-mt-1 -mb-1.5 sm:mt-5 sm:mb-4 flex justify-center" data-id="element-138" data-mp="39a38120t7hnu">
          <img src={MOCKUP_URL} alt="Kit Menopausia + Perimenopausia en formato libro, tablet y celular" className="w-full max-w-[318px] sm:max-w-[460px] h-auto mx-auto px-2 sm:px-6" width={1080} height={1080} loading="eager" fetchPriority="high" decoding="async" data-id="element-139" data-mp="3e84n7bv46wu1" />
        </div>

        <p className="font-serif text-rose-600 font-bold tracking-tight leading-tight text-lg sm:text-2xl md:text-3xl" data-id="element-140" data-mp="2vjzqupgsee59">
          EL SISTEMA +40 PARA ENTENDER ESTA ETAPA
        </p>

        <p className="text-ink-muted max-w-2xl mx-auto text-[14px] sm:text-base leading-snug sm:leading-relaxed mt-1 mb-2 sm:mt-3 sm:mb-6" data-id="element-141" data-mp="2lla5gmpombk9">
          Sofocos, sueño, cansancio, irritabilidad y cambios corporales:
          entendé qué puede estar cambiando y qué podés empezar a hacer desde
          hoy.
        </p>

        <div className="flex flex-wrap justify-center gap-1.5 sm:gap-2 mb-3 sm:mb-7" data-id="element-142" data-mp="id9tudnwcbtt">
          <Badge className="whitespace-nowrap px-2 py-0.5 text-[11px] sm:px-3 sm:py-1 sm:text-xs" data-id="element-143" data-mp="ddwy13f1ruf3">
            <span className="mr-1 sm:mr-1.5" aria-hidden="true" data-id="element-144" data-mp="1b15qjidgu3ql">🌿</span> 5 Guías + 3 Bonos
          </Badge>
          <Badge className="whitespace-nowrap px-2 py-0.5 text-[11px] sm:px-3 sm:py-1 sm:text-xs" data-id="element-145" data-mp="162ugb6j9dr7u">
            <FileText className="w-3.5 h-3.5 mr-1 sm:mr-1.5 text-rose-500" data-id="element-146" data-mp="111oln361ftvo" /> 100% Digital
          </Badge>
          <Badge className="whitespace-nowrap px-2 py-0.5 text-[11px] sm:px-3 sm:py-1 sm:text-xs" data-id="element-147" data-mp="x0cq6h0hgefk">
            <Zap className="w-3.5 h-3.5 mr-1 sm:mr-1.5 text-rose-500" data-id="element-148" data-mp="3ltqbtahzursg" /> Acceso inmediato
          </Badge>
        </div>

        <div className="flex flex-col items-center gap-2.5 sm:gap-5" data-id="element-149" data-mp="3hq266xcxa69u">
          <Button size="md" className="w-full max-w-xl group leading-snug text-center px-5 sm:px-6 py-3.5 sm:py-3.5 text-[16px] sm:text-[15px] sm:whitespace-nowrap" onClick={() => document.getElementById('planes')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-150" data-mp="1xacf521xbhsp">
            <span data-id="element-151" data-mp="2g02k2hzehjyc">
              <span className="block sm:inline" data-id="element-152" data-mp="2g0lqb1foujwj">QUIERO ENTENDER QUÉ ME PASA</span>{' '}
              <span className="block sm:inline" data-id="element-153" data-mp="2kyduattlxwh3">Y EMPEZAR AHORA</span>
            </span>
            <ArrowRight className="hidden sm:block ml-2 w-5 h-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-154" data-mp="2p0qn6hn99zwg" />
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-x-4 sm:gap-x-6 gap-y-1 sm:gap-y-2 text-xs sm:text-sm text-ink-muted" data-id="element-155" data-mp="2tysfzuahhdl4">
            <span className="flex items-center" data-id="element-156" data-mp="zl0zcatqltg6">
              <ShieldCheck className="w-4 h-4 mr-1 text-sage-600" data-id="element-157" data-mp="zlsx9sat439m" /> Garantía 7 días
            </span>
            <span className="flex items-center" data-id="element-158" data-mp="49jdg5ykopmn">
              <Lock className="w-4 h-4 mr-1 text-ink-soft" data-id="element-159" data-mp="3vi6yekswiato" /> Pago seguro
            </span>
            <span className="flex items-center" data-id="element-160" data-mp="e9aaaealvgpw">
              <Zap className="w-4 h-4 mr-1 text-rose-500" data-id="element-161" data-mp="e91w8j2qy5d4" /> Acceso inmediato
            </span>
          </div>
        </div>
      </div>
    </section>;
}